module.exports = __webpack_public_path__ + "static/media/female.d8ec0aa7.jpg";